'use client';

import styles from './InputSwitch.module.scss';

export type InputSwitchProps = {
  name: string;
  inputValue: number;
  checked?: boolean;
  onChange: (e: React.ChangeEvent) => void;
  inputRef?: React.Ref<HTMLInputElement>;
  reversed?: boolean;
};

function InputSwitch({ name, inputValue, checked = true, onChange, inputRef, reversed = false }: InputSwitchProps) {
  return (
    <label
      className={`${styles.inputSwitch} ${
        // biome-ignore lint/suspicious/noDoubleEquals: <explanation>
        reversed == true ? styles.reversed : ''
      }`}
    >
      <input
        type='checkbox'
        name={name}
        ref={inputRef}
        value={inputValue}
        checked={checked}
        onChange={(e) => onChange(e)}
      />
      <span className={styles.toggle} />
    </label>
  );
}

export default InputSwitch;
